import React from 'react';

const SuccessAlert = (props) => {
    return ( 
        props.message.length > 0 &&
        <div className="alert alert-success alert-dismissible fade show" role="alert">
            <strong>Success!</strong> {props.message}
            <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
     );
}
 
export default SuccessAlert;